import * as React from 'react';

function SvgCard(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M2 17.358a2.5 2.5 0 002.5 2.5h15a2.5 2.5 0 002.5-2.5v-6.875H2v6.875zm2.946-3.393a1.34 1.34 0 011.34-1.34h2.143a1.34 1.34 0 011.339 1.34v.893a1.34 1.34 0 01-1.34 1.34H6.287a1.34 1.34 0 01-1.34-1.34v-.893zM19.5 4.144h-15a2.5 2.5 0 00-2.5 2.5v1.16h20v-1.16a2.5 2.5 0 00-2.5-2.5z" })));
}

export default SvgCard;
